import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/trucks/create'
)({
  // TODO: USER_TYPE.OWNERもしくはPARTNER_ROLE.MANAGER以外の場合にリダイレクトさせる
  // beforeLoad: ({ context: { auth } }) => {
  //   if (auth.user.type !== USER_TYPE.OWNER) {
  //     throw redirect({
  //       to: `/${getDefaultUserMeTenant(auth.user).key}/settings/trucks`
  //     })
  //   }
  // },
  loader: async ({ context: { auth } }) => {
    return {
      authUser: auth.user
    }
  },
  meta: () => [{ title: MENU.NEW_REGISTRATION }]
})
